<script lang="ts">
	import { NewsCardGrid } from '#lib/features/news/components/NewsCardGrid/index.js';
	import { NewsPageBody } from '#lib/websites/news/components/NewsPageBody/index.js';
	import { NewsHomePage } from '#lib/websites/news/pages/NewsHomePage/index.js';
	import { browser } from '$app/env';
</script>

{#if browser}
	<NewsHomePage />
{:else}
	<NewsPageBody
		class="flex min-h-[calc(100vh-96px)] flex-col sm:min-h-[calc(100vh-148px)] md:min-h-[calc(100vh-157px)] lg:min-h-[calc(100vh-152px)]"
	>
		<NewsCardGrid loading />
	</NewsPageBody>
{/if}
